import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    window.alert(this.element.textContent.trim())
    this.element.remove()
  }
}
